import { FilePdfOutlined } from '@ant-design/icons'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { useApproveTum } from 'app/react-query/hook/newTumRegister'
import { handleDownloadFile } from 'app/service/general/service'
import { useRef } from 'react'
import { ENewTumRegisterStatus } from '../../type'
import { convertedVariables } from 'app/styles/themes/themeVariables'

interface IProps {
  name?: string
  id?: string
  file?: string
  fileName?: string
}

export const ReApproveTumModal = ({ name, id, file, fileName }: IProps) => {
  const modalRef = useRef<IRefModal>({})

  const { mutateAsync: mutateAsyncApprove, isLoading } = useApproveTum()

  const onSubmit = async () => {
    if (!id) {
      return
    }

    try {
      await mutateAsyncApprove({
        id: parseInt(id),
        status: ENewTumRegisterStatus.ACCEPTED,
        reason: 'Đã xác thực'
      })
      modalRef.current?.hide?.()
    } catch (error) {
      console.log('Error:', error)
    }
  }
  const onClickDownloadFile = async () => {
    if (fileName && file) {
      await handleDownloadFile({
        fileName,
        fileUrl: file,
      })
    }
  }
  return (
    <BaseModalComponent
      titleModal={'Xác nhận'}
      titleOpenModal="Phê duyệt lại"
      styleButtonOpen={{
        border: `1px solid ${convertedVariables.neutralBlack2Color}`,
        borderRadius: 8
      }}
      widthModal={400}
      ref={modalRef}
      handleSubmit={onSubmit}
      isLoadingConfirm={isLoading}
      renderContent={
        <BaseSpace>
          <BaseRow gutter={8} align={'middle'} justify={'center'}>
            <BaseCol>
              <BaseText fontWeight="medium" fontSize="xs">
                {'Bạn có thực sự muốn phê duyệt lại đoàn viên?'}
              </BaseText>
            </BaseCol>
            <BaseCol>
              <BaseText
                children={`"${name ?? ''}"`}
                colorText="statesRedColor"
                fontWeight="medium"
                fontSize="xs"
              />
            </BaseCol>
          </BaseRow>

          {fileName ? <BaseRow
            gutter={6}
            align={'middle'}
            style={{ cursor: 'pointer' }}
            onClick={onClickDownloadFile}
            justify={'start'}
          >
            <BaseCol>
              <FilePdfOutlined rev={undefined} />
            </BaseCol>
            <BaseCol>
              <BaseText
                children={fileName}
                colorText="collapseBackgroundColor"
                fontWeight="medium"
              />
            </BaseCol>
          </BaseRow> : null}
        </BaseSpace>
      }
    />
  )
}
